import * as Redux from 'redux'
import * as Form from '../../../components/form'
import * as Sortable from '../../../components/sortable'
import * as Elasticsearch from '../../../elasticsearch'
import * as Request from '../../../request'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

const normalizeTypes: Sortable.TypeNormalizer<Types.TopTopic> =
  (payload: any): Sortable.SortableData<Types.TopTopic> => Utils.getTopTopics(payload)

const reducerEvent = (eventName: string): Sortable.ReducerEvent<Types.TopTopic> => {
  return {
    defaultSort: { field: 'count', dir: 'desc' },
    normalizer: normalizeTypes,
    requestEvent: eventName,
  }
}

const initialFieldValues: Types.FormFields = {
  community: null,
  dateRange: Elasticsearch.DateRanges.LastMonth,
  endDate: null,
  startDate: null,
}

export const topTopicsReducer = (
  fetchEvent: string,
  filterEvent: string,
  ) => {
  const e = reducerEvent(fetchEvent)
  return Redux.combineReducers({
    data: Request.reducerChain([
      Sortable.stateReducer(e),
    ]),
    form: Form.createReducer(filterEvent, initialFieldValues),
    view: Request.reducerChain([
      Sortable.viewReducer(e),
    ]),
  })
}

export const reducer = topTopicsReducer(
  Constants.FETCH_TOP_TOPICS,
  Constants.TOP_TOPICS_FILTER,
)



// WEBPACK FOOTER //
// ./src/pages/reports/top-topics/reducer.ts